import { render, staticRenderFns } from "./addTable.vue?vue&type=template&id=57c57ad3&"
import script from "./addTable.vue?vue&type=script&lang=js&"
export * from "./addTable.vue?vue&type=script&lang=js&"
import style0 from "./addTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports